import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { IS1InputSelectItem } from '@app/s1';
import { TranslateService } from '@ngx-translate/core';
import { TipoCodice } from '@app/shared/models/assistenza';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private translate: TranslateService
  ) { }

  UTCDateFromLocal(date: Date, isEndOfDay: boolean = false): Date {
    if (date == null) { return date }
    var onlyDayDateString = new DatePipe('en-EN').transform(date, 'yyyy-MM-dd');
    onlyDayDateString += isEndOfDay ? 'T23:59:59Z' : 'T00:00:00Z' ;
    return new Date(onlyDayDateString);
  }


  UTCDateTimeFromLocal(date: Date): Date {
    if (date == null) { return date }
    var onlyDayDateString = new DatePipe('en-EN').transform(date, 'yyyy-MM-dd HH:mm:ss');
    
    return new Date(onlyDayDateString);
  }


  UTCDateTimeFromLocalIT(date: Date | string): string {
    if (date == null) { return null }
    return new DatePipe('it-IT').transform(date, 'dd/MM/YYYY HH:mm:ss');
  }

  capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // Converte il vecchio filtro "con/senza barcode" nel filtro sul tipo codice (RMPP e violazioni hanno la stessa gestione)
  tipiCodiceDaConBarcode(conBarcode: boolean | string): TipoCodice[] {
    if (conBarcode === true || conBarcode === 'true') { return [TipoCodice.Rmpp, TipoCodice.Violazione]; }
    if (conBarcode === false || conBarcode === 'false') { return [TipoCodice.Nessuno]; }
    return null;
  }

  getInputSelectFromEnum(enumType: any, translatePrefix?: string): IS1InputSelectItem[] {
    return Object.entries(enumType)
    .filter(([_, value]) => typeof value === 'string')
    .map(([key, value]) => {
      const label = translatePrefix
        ? this.translate.instant(`${translatePrefix}.${key}`)
        : this.capitalizeFirstLetter(value.toString());
      return { code: key, label: label }
    });
  };

}
